module.exports = function () {
    // global functionality goes here

    var $body = $('body');
    $body.addClass('jsenabled');


    // check if browser is IE - if true, add body class
    var isIE = navigator.appName == 'Microsoft Internet Explorer' ||
        !!(navigator.userAgent.match(/Trident/) ||
            navigator.userAgent.match(/rv:11/)) ||
        (typeof $.browser !== "undefined" && $.browser.msie == 1);

    if (isIE) {
        $body.addClass('browser-ie');
    }


    // push gtm-event data-values on anchors to datalayer
    $body.on('click', '[data-gtm-event]', function () {
        let gtm_event = $(this).data('gtm-event');
        let page_url = $(location).attr('href');

        // console.log({'dbk_category' : 'click_event', 'dbk_event' : gtm_event, 'dbk_url' : page_url }); // development

        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({ 'dbk_category': 'click_event', 'dbk_event': gtm_event, 'dbk_url': page_url }); // production
        }
    });

    $('form.auto-submit').change(function () {

        $('.filter-loader-overlay').stop().fadeIn(150, 'easeInOutCubic');
        this.submit();
    });


    // prevent disabled buttons to execute default actions
    $('.btn-disabled').click(function (e) {
        e.preventDefault();
    });


    // unfocus links after click
    $('a').click(function () {
        $(this).blur();
    });

    // when a link is clicked with href attribute starting with #, scroll that shit smoothly (if target exists)
    $('a[href^="#"]').click(function (e) {
        e.preventDefault();
        var $this = $(this);
        var target = $(this).attr('href');
        var scrollOffset = $('header[role="masthead"] .header').outerHeight();

        // check if target is more than just a # dummy link
        if (target.length > 1) {

            if ($this.data('extra-scroll-offset')) {
                scrollOffset = scrollOffset + $(this).data('extra-scroll-offset');
            }

            // if target exists
            if ($(target).length > 0) {
                // if target has section-margin class, increase offset
                if ($(target).hasClass('section-margin')) {
                    if ($(window).width() > 480) {
                        scrollOffset = scrollOffset + 60;
                    } else {
                        scrollOffset = scrollOffset + 30;
                    }
                }

                $('html, body').animate({
                    scrollTop: $(target).stop().offset().top - scrollOffset
                }, 1000, 'easeInOutCubic', function () {
                    $this.blur();
                });
            }
        }
    });

    // init lightbox
    $('a.lightbox').nivoLightbox({
        afterShowLightbox: function () {
            var src = $('.nivo-lightbox-content > iframe').attr('src');
            $('.nivo-lightbox-content > iframe').attr('src', src + '?autoplay=1&rel=0&disablekb=1&fs=0');
        }
    });



    // disable hero-video with URL variable
    if (window.location.search.indexOf('no_video=1') >= 0) {
        $('section.hero .hero__background-video').remove();
    }

    let $heroSubtitleVariable = $('.hero__subtitle-variable');
    if ($heroSubtitleVariable.length) {
        let current = 0,
            arr = $heroSubtitleVariable.data('variable-words').split(','),
            delay = $heroSubtitleVariable.data('delay');

        setInterval(() => {
            $heroSubtitleVariable.addClass('hero__subtitle-variable--invisible');

            setTimeout(() => {
                $heroSubtitleVariable.text(arr[current]);
                $heroSubtitleVariable.removeClass('hero__subtitle-variable--invisible')
            }, 150);

            if (current === arr.length - 1) {
                current = 0;
            } else {
                current++;
            }
        }, delay);
    }


    // search-bar overlay
    $('#show-search').click(function (e) {
        e.preventDefault();
        var $search = $('section.search-overlay');

        if ($search.hasClass('search-overlay--visible')) {
            $search.removeClass('search-overlay--show-form');
            setTimeout(function () {
                $search.removeClass('search-overlay--visible');
            }, 300);
        } else {
            $search.addClass('search-overlay--visible');
            setTimeout(function () {
                $search.addClass('search-overlay--show-form');
                $search.find('input').focus();
            }, 300);
        }
    });

    $('#close-search').click(function (e) {
        e.preventDefault();
        var $search = $('section.search-overlay');

        if ($search.hasClass('search-overlay--visible')) {
            $search.removeClass('search-overlay--show-form');
            setTimeout(function () {
                $search.removeClass('search-overlay--visible');
            }, 300);
        }
    });


    // menu overlay
    $('#show-menu').click(function (e) {
        e.preventDefault();
        var $menu = $('section.menu-overlay');

        if ($menu.hasClass('menu-overlay--visible')) {
            $menu.removeClass('menu-overlay--show-contents');
            setTimeout(function () {
                $menu.removeClass('menu-overlay--visible');
                $body.removeClass('show-menu');
            }, 300);
        } else {
            $body.addClass('show-menu');
            $menu.addClass('menu-overlay--visible');
            setTimeout(function () {
                $menu.addClass('menu-overlay--show-contents');
            }, 300);
        }
    });

    $('#close-menu').click(function (e) {
        e.preventDefault();
        var $menu = $('section.menu-overlay');

        if ($menu.hasClass('menu-overlay--visible')) {
            $menu.removeClass('menu-overlay--show-contents');
            setTimeout(function () {
                $menu.removeClass('menu-overlay--visible');
                $body.removeClass('show-menu');
            }, 300);
        }
    });


    // On request of the client, disabled the opening hours plugin
    /*
    $.ajax({
        'url': DBK.site_url + '/wp-json/dbk/v1/get-openinghours'
    }).done(function (data) {
        if ('OK' === data.status) {
            $('.open-today-message').hide().html(data.html_today).fadeIn();
            if( data.is_open ) {
                $( '.hours-orb' ).removeClass( 'closed' ).addClass( 'open' );
            } else {
                $( '.hours-orb' ).removeClass( 'open' ).addClass( 'closed' );
            }
        }
    });
    */

    // add home icon in main nav
    $('header[role="masthead"] .nav-bar .menu > .menu-item.icon-home > a').html('<i class="fa fa-home"></i>');
    // add drop-down arrow's in menu-items with children
    $('header[role="masthead"] .nav-bar .menu > .menu-item.menu-item-has-children > a').append('<i class="icon-right far fa-angle-down"></i>');
    $('section.menu-overlay .nav-primary .menu > .menu-item.menu-item-has-children').append('<span class="toggle-sub-menu"><i class="far fa-plus"></i></span>');


    // toggle sub-menu in menu-overlay
    $('section.menu-overlay .menu > .menu-item.menu-item-has-children .toggle-sub-menu').click(function () {
        var $wrapper = $(this).closest('.menu-item');
        var $menu = $(this).siblings('.sub-menu');

        if ($wrapper.hasClass('.sub-menu--visible')) {
            $wrapper.removeClass('.sub-menu--visible');
            $menu.stop().slideUp(300, 'easeInOutCubic');
        } else {
            // close other sub-menu's that might be open
            $wrapper.siblings().each(function () {
                var $sibling = $(this);

                if ($sibling.hasClass('.sub-menu--visible')) {
                    $sibling.removeClass('.sub-menu--visible');
                    $sibling.find('.sub-menu').stop().slideUp(300, 'easeInOutCubic');
                }
            });
            $wrapper.addClass('.sub-menu--visible');
            $menu.stop().slideDown(300, 'easeInOutCubic');
        }
    });


    var $wrapper = $('header[role="masthead"]');
    var $header = $wrapper.find('.header');

    var $bottomBar = $('.sticky-bottom-bar');
    var $footer = $('footer[role="site-footer"]');

    var $window = $(window);
    // functions on scroll event
    $(document).scroll(function () {
        var distanceScrolled = $(document).scrollTop();
        var wrapperOffset = $wrapper.offset();

        // sticky header
        if ($header.length) {
            var header_topOffset = wrapperOffset.top;

            if (distanceScrolled > header_topOffset) {
                if (!$header.hasClass('header--fixed')) {
                    $wrapper.addClass('masthead--header-fixed');
                    $header.addClass('header--fixed');
                }
            } else {
                if ($header.hasClass('header--fixed')) {
                    $header.removeClass('header--fixed');
                    $wrapper.removeClass('masthead--header-fixed');
                }
            }
        }

        // show/hide sticky-bottom-bar
        if ($window.width() > 675 && $bottomBar.length) {
            var bottomBar_topOffset = $wrapper.outerHeight() + wrapperOffset.top;
            var bottomBar_bottomOffset = $footer.offset().top;

            if (distanceScrolled > bottomBar_topOffset) {
                if ((distanceScrolled + $window.height()) < bottomBar_bottomOffset) {
                    if (!$bottomBar.hasClass('sticky-bottom-bar--visible')) {
                        $bottomBar.addClass('sticky-bottom-bar--visible');
                    }
                } else {
                    if ($bottomBar.hasClass('sticky-bottom-bar--visible')) {
                        $bottomBar.removeClass('sticky-bottom-bar--visible');
                    }
                }
            } else {
                if ($bottomBar.hasClass('sticky-bottom-bar--visible')) {
                    $bottomBar.removeClass('sticky-bottom-bar--visible');
                }
            }
        }
    });

    // insert check icon elements to ul.list-checked in content-wrapper
    $('.content-wrapper .list-checked > li').each(function () {
        $(this).prepend('<i class="item-icon far fa-check"></i>');
    });


    // faqs
    $('.faqs-wrapper .faq').click(function (e) {
        e.preventDefault();

        var $content = $(this).find('.faq-answer');

        if ($(this).hasClass('toggled')) {
            $(this).removeClass('toggled');
            $content.stop().slideUp(300, 'easeInOutCubic', true);
        } else {
            $(this).addClass('toggled');
            $content.stop().slideDown(300, 'easeInOutCubic', true);
        }
        $(this).blur();
    });
    // expand pre-toggled faqs on page-load
    $('.faqs-wrapper .faq.toggled').each(function () {
        var $content = $(this).find('.faq-answer');
        $content.show();
    });


    // convert paragraph if first-child to intro text when certain class is found
    $('.convert-first-paragraph-to-intro p:first-child').addClass('intro');


    // package tabs functionality
    // open correct tab on pageload
    $('.package__tabs').each(function () {
        var current = $(this).find('.tab.tab--current').data('tab-id');
        var $content = $(this).next('.package__tabbed-content');

        $content.find('[data-tab-id="' + current + '"]').addClass('tab-content--visible');
    });

    // switch tab on click
    $('.package__tabs .tab a').click(function (e) {
        e.preventDefault();
        var target = $(this).closest('.tab').data('tab-id');
        var $content = $(this).closest('.package__tabs').next('.package__tabbed-content');

        $(this).closest('.tab').addClass('tab--current').siblings().removeClass('tab--current');
        $content.find('[data-tab-id="' + target + '"]').addClass('tab-content--visible').siblings().removeClass('tab-content--visible');
    });


    // init masonry galleries
    jQueryBridget('isotope', Isotope, $); // for reference: https://isotope.metafizzy.co/extras.html
    $('.gallery-wrapper .masonry-grid').each(function () {
        var $container = $(this);

        $container.imagesLoaded(function () {

            $container.isotope({
                itemSelector: '.grid-item',
                percentPosition: true
            });

            if ($container.hasClass('masonry-grid--loading')) {
                $container.removeClass('masonry-grid--loading');
            }
        });
    });


    // insert dropdown icons to woocommerce select elements
    $('.woocommerce .woocommerce-ordering select, .woocommerce table.variations select, .woocommerce .wc_bookings_field_resource select').each(function () {
        $(this).wrap('<div class="input-wrapper"></div>');
        $(this).parent().append('<div class="field_icon"><i class="fas fa-sort"></i></div>');
    });


    // wrap table elements inside .content areas in .table-wrapper div
    $('body.woocommerce table, body.woocommerce-page table').each(function () {
        $(this).wrap('<div class="shop_table_overflow_wrapper"></div>');
    });


    $('p').each(function () { // filter out empty paragraphs
        let $paragraph = $(this);

        if ('&nbsp;' === $paragraph.html()) {
            $paragraph.remove();
        }
    });


    // toggle siblings on mobile
    $('.siblings__toggle').on('click', function () {
        let $toggle = $(this),
            $label = $toggle.find('.siblings__toggle-text'),
            $siblings = $toggle.siblings('.siblings__inner').find('.siblings__list'),
            classToggled = 'siblings__toggle--toggled',
            text = $toggle.data('text'),
            textToggled = $toggle.data('text-toggled');

        if ($toggle.hasClass(classToggled)) {
            $toggle.removeClass(classToggled);
            $label.text(text);
            $siblings.stop().slideUp(150);
        } else {
            $toggle.addClass(classToggled);
            $label.text(textToggled);
            $siblings.stop().slideDown(150);
        }
    });


    // load extra JS parts
    require('./dropdown-windows.js');
    require('./number-controls.js');
    require('./gravity-forms.js');
    require('./filters.js');
    require('./modals.js');
    require('./sliders.js');
    require('./mews.js');
    require('./download-file.js');
    require('./hero-video.js');
    require('./pikaday.js'); 

};
